export enum BRAND_FILTER_TYPE {
  TODAY = 'Today',
  YESTERDAY = 'Yesterday',
  LAST_7_DAYS = 'Last 7 days',
  LAST_30_DAYS = 'Last 30 days',
  CUSTOM = 'Custom',
  DEFAULT = ''
}

export interface IBrandSummaryDateFilter {
  startTime?: number
  endTime?: number
  filterType: BRAND_FILTER_TYPE
}

export enum BRAND_SUMMARY_TYPES {
  ORDER_SUMMARY = 1,
  ORDER_SUMMARY_ITEMS = 2,
  ORDER_SUMMARY_BY_GROUP_ID = 3
}
export type FilterDrawerType =
  | 'Distributor Name'
  | 'Product Description'
  | 'Product Code'
  | 'Distributor Region'
  | 'Distributor Branch'
  | ''
export interface IBrandSummaryState {
  loaders: {
    outerGroupSummary: boolean
    innerSummaryItems: boolean
    fetchingProductMapping: boolean
    uploadingProductMapping: boolean
  }
  activeFilter: IBrandSummaryDateFilter | null
  brandSaleSummary: IBrandSaleSummary[] | null
  brandReportItems: IBrandReportSummary[] | null
  brandOverallSaleSummary: IBrandSaleSummary | null
  filterDrawerType: FilterDrawerType
  dataList: string[]

  filteredData: {
    distributorNameFilter: string[]
    productCodeFilter: string[]
    productDescriptionFilter: string[]
    regionFilter: string[]
    branchFilter: string[]
  }
  downloadFilteredView: boolean
  brandProductMapping: IBrandProductMapping['products']
  allProductCode: Set<string>
  allProductName: Set<string>
  productCodeToProductIdMapper: Map<string, string>
  productNameToProductIdMapper: Map<string, string[]>

  pageSize: number
  page: number
  totalCount: number
}

export type SelectedDataKey =
  | 'distributorNameFilter'
  | 'productCodeFilter'
  | 'productDescriptionFilter'
  | 'regionFilter'
  | 'branchFilter'

export interface IFetchBrandSummaryActionPayload {
  startTime: number
  endTime: number
  filterType: BRAND_FILTER_TYPE
}

export enum BRAND_ACTION_ENUM {
  JSON = 'json',
  EXCEL = 'excel'
}

export interface FilterBy {
  distributor_ids?: string[]
  brand_inv_ids?: string[]
}

export interface IFetchBrandReportPayload {
  distributorId: string
  fromDate: number
  toDate: number
  format: BRAND_ACTION_ENUM
  filterType: BRAND_FILTER_TYPE
  filters?: FilterBy
  paginationData?: {
    page: number
    pageSize: number
  }
}

export interface IBrandSaleSummary {
  distributor_id: string
  invoice_count: number
  sale_quantity: number
  sale_amount: number
}

export interface IBrandProductMapping {
  products: {
    id: string
    product_name: string
    product_code: string
  }[]
}

export interface IBrandReportSummary {
  region: string
  branch: string
  distributor_code: string
  distributor_name: string
  invoice_number: string
  invoice_date: number
  party_code: string
  customer_name: string
  product_code: string
  product_description: string
  product_group: string
  sales_voucher_type: string
  quantity: number
  net_amount: number
  tax_amount: number
  gross_amount: number
}

// export interface IFetchOrderGroupSummaryActionPayload {
//   startTime: number
//   endTime: number
//   filterType: BRAND_FILTER_TYPE
//   groupId: string
// }

// export interface IOrderSummaryFormattedData {
//   groupName: string
//   totalOrders: number
//   totalAmount: number
//   totalAcceptedAmount: number
//   totalPendingAmount: number
// }

// export interface IOrderSummaryListFormattedData extends IOrderSummaryFormattedData {
//   groupId: string
// }

// export enum ORDER_STATUS_TYPES {
//   DEFAULT = 0,
//   PENDING = 1,
//   APPROVED = 2,
//   PROFORMA_CREATED = 3,
//   INVOICED = 4,
//   CANCELLED = 5,
//   REJECTED = 6,
//   OUT_FOR_DELIVERY = 7,
//   COMPLETED = 8
// }

// export interface IOrderSummaryGroupFormattedData extends IOrderSummaryListFormattedData {
//   orderDetails: {
//     number: string
//     customerName: string
//     amount: number
//     status: ORDER_STATUS_TYPES
//     createTime: string
//     updateTime: string
//   }[]
// }

// export interface IFetchOrderGroupSummaryDownlaodActionPayload
//   extends IFetchOrderGroupSummaryActionPayload {
//   fileName: string
// }

// export interface IOrderSummaryStats {
//   group_name: string
//   total_orders: number
//   total_orders_value: number
//   total_ordered_qty: number
//   total_accepted_qty: number
//   total_rejected_qty: number
//   total_pending_qty: number
//   total_pending_orders_value: number
// }

// export interface IOrderSummaryItemLevelStats {
//   order_number: string
//   customer_name: string
//   zone: string
//   area: string
//   item_category: string
//   item_name: string
//   sku: string
//   rate: number
//   ordered_quantity: number
//   order_item_value: number
// }
